module.exports = __webpack_public_path__ + "static/img/_posing.a11b1d7c.png";